import React, { useEffect, useState } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import { API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';
import Subtitle from '../../core/Subtitle/index';

const EventPlayer = () => {
  const [image, setImage] = useState();
  const [logo, setLogo] = useState();
  const [url, setUrl] = useState();
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'player') {
          setImage(el.icon);
          setLogo(el.logo);
          setUrl(el.url);
        }
        return image;
      });
    });
  }, []);
  return (
    <div>
      <Subtitle>{url}</Subtitle>
      <MuxPlayer
        streamType="on-demand"
        playbackId={image}
        poster={logo}
        style={{ height: '23em' }}
      />
    </div>
  );
};

export default EventPlayer;
